import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-location-details',
  templateUrl: 'rmt-location-details.html'
})
export class RmtLocationDetailsComponent {
  @Input() location;
  @Input() country;
  buttons;

  constructor() {    
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-location-details/rmt-location-details.ts